import { Suspense } from "react";
import { Outlet, Link } from "react-router";

import { Badge } from "@/components/ui/badge";
import { PageLoader } from "@/components/PageLoader";
import { ThemeToggle } from "@/components/ThemeToggle";
import { ROUTES } from "@/constants/routes";

/**
 * docs/ui/layouts.md's `AdminShell` — desktop-only by design (no admin
 * roles exist in the auth model yet either, per that doc's own open items).
 * The fixed `AdminSidebar` (Dashboard/Users/Listings/Reports/Settings) and
 * `AdminTopBar` are real, well-defined content per `ui-architecture.md` §8,
 * but every one of their links points at an admin route that's gated on a
 * role the User model doesn't have yet — the sidebar rail below is
 * structural only (the fixed-width column `AdminShell` is defined by),
 * left empty rather than populated with nav items that would 404 or bypass
 * a role check that doesn't exist.
 */
export function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-background">
      <aside className="hidden w-60 shrink-0 border-r border-border bg-card md:block" />
      <div className="flex flex-1 flex-col">
        <header className="flex h-16 shrink-0 items-center justify-between border-b border-border px-4">
          <Link to={ROUTES.dashboard} className="text-h3 text-foreground">
            BazaarX Admin
          </Link>
          <div className="flex items-center gap-3">
            <Badge variant="success">System OK</Badge>
            <ThemeToggle />
          </div>
        </header>
        <main className="flex-1">
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
